import styled from 'styled-components'

import { Section as GSSection } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, space, colors } = theme

export const Section = styled(GSSection)`
  h2 {
    margin-bottom: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    padding-top: 7.5rem;

    h2,
    span {
      font-size: 3.5rem;
    }

    p {
      font-size: 1.375rem;
    }
  }
`

export const ItemList = styled.div`
  padding: ${space['spacing-lg']} 0 0 ${space['spacing-md']};

  p {
    padding-bottom: ${space['spacing-xxxs']};
  }

  ul.disc {
    list-style-type: disc;
    color: ${colors['neutral-text-contrast-default']};
  }
`

export const WarningWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  margin-top: ${space['spacing-md']};
  gap: ${space['spacing-md']};

  @media (${media.desktop}) {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
  }
`

export const Warning = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['spacing-sm']};
  padding: ${space['spacing-sm']};
  border: solid #D4DFFE 1px;
  border-radius: ${space['spacing-xs']};

  p {
    color: #D4DFFE;
  }

  @media (${media.desktop}) {
    flex-direction: row;

    p {
      font-size: 1.125rem;
    }
  }
`

export const IconImage = styled.div`
  min-width: 86px;
  width: 86px;
`

